import axios from 'axios'
import get from 'lodash/get'
import BlogApp from 'apps/Blog'
import { getCommonStaticProps } from 'commonPage'
import commonMessages from 'lang/es/common'
import blogMessages from 'lang/es/blog'
import { safePromise } from 'utils/universal/safePromise'
import { mapBlogPost } from 'mappers/blogMapper'

export default BlogApp

export const getServerSideProps = async (context) => {
  const commonStaticProps = await getCommonStaticProps()
  const messages = {
    ...commonMessages,
    ...blogMessages,
  }
  const {
    query,
  } = context
  const page = get(query, 'page', 1)
  const search = get(query, 'search', '')
  const postsUrl = `${process.env.NEXT_PUBLIC_API_WORDPRESS}/wp/v2/posts?_embed&per_page=12&page=${page}&search=${search}`
  const { result } = await safePromise(axios(postsUrl))
  const postsData = get(result, 'data', [])
  const totalPages = get(result, 'headers.x-wp-totalpages', 1)
  const posts = postsData.map(mapBlogPost)
  return {
    props: {
      titleMeta: 'BLOG_TITLE',
      descriptionMeta: 'BLOG_DESCRIPTION',
      activeTitleMetaComplement: true,
      defaultTitleMetaComplement: true,
      messages,
      ...commonStaticProps,
      posts,
      page: Number(page),
      totalPages: Number(totalPages),
      search,
      headerProps: {
        activeIndex: 3,
        breadcrumbs: [],
      },
    },
  }
}
